import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ThemeColorDirective } from 'src/app/core/utils/theme/theme-color.directive';
import { TranslationModule } from '../../../i18n/translation.module';
import { MaterialModule } from '../../modules/material/material.module';
import { PaginatorComponent } from './paginator.component';

@NgModule({
  declarations: [PaginatorComponent],
  imports: [
    CommonModule,
    MaterialModule,
    TranslationModule,
    FormsModule,
    ThemeColorDirective,
  ],
  exports: [PaginatorComponent],
})
export class PaginatorModule {}
